import {
  AdminAnalyticsEvents,
  createAnalyticsClient,
  type AnalyticsClient
} from "@veritrellis/analytics";
import { adminAnalyticsEnv } from "./analyticsEnv.js";

export { AdminAnalyticsEvents };

export const analytics: AnalyticsClient = createAnalyticsClient({
  apiKey: adminAnalyticsEnv.apiKey,
  host: adminAnalyticsEnv.ingestHost,
  uiHost: adminAnalyticsEnv.uiHost,
  enabled: adminAnalyticsEnv.enabled,
  surface: "admin",
  crossSubdomainCookie: adminAnalyticsEnv.crossSubdomainCookie
});
